import { render, staticRenderFns } from "./FinancialDataGuv.vue?vue&type=template&id=ab96fd04&scoped=true"
import script from "./FinancialDataGuv.vue?vue&type=script&lang=js"
export * from "./FinancialDataGuv.vue?vue&type=script&lang=js"
import style0 from "./FinancialDataGuv.vue?vue&type=style&index=0&id=ab96fd04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab96fd04",
  null
  
)

export default component.exports